import { useDashboard } from '../../../context/DashboardContext';
import { useGardenSettings } from '../../../context/GardenSettingsContext';

/**
 * GardenStatsBlock — "Dein Grünraum"
 *
 * Shows three stats:
 *   - Pflanzen  (placedPlants.length)
 *   - Fläche    (getGardenArea() m²)
 *   - Höhenzonen (heightDifferences.zones.length)
 *
 * State 0: plant count = 0, area = "–", zones = "–"
 * State A/B: real values
 */
const GardenStatsBlock = () => {
  const { carePhase, placedPlants, setActiveView } = useDashboard();
  const { getGardenArea, settings } = useGardenSettings();
  const { state } = carePhase;

  const isState0 = state === '0';
  const plantCount = isState0 ? 0 : placedPlants.length;
  const area = getGardenArea();
  const zonesCount = settings.heightDifferences?.zones?.length ?? 0;

  const areaDisplay = isState0 || area === 0 ? '–' : `${Math.round(area)} m²`;
  const zonesDisplay = isState0 ? '–' : String(zonesCount);

  return (
    <section className="bg-white rounded-xl shadow-sm p-6">
      <h2 className="text-base font-bold text-gray-900 mb-6">Dein Grünraum</h2>
      <div className="grid grid-cols-3 gap-4">
        <div className="text-center">
          <div className={`text-2xl font-bold ${isState0 ? 'text-gray-300' : 'text-gray-900'}`}>
            {plantCount}
          </div>
          <div className="text-xs text-gray-500 mt-1">
            Pflanzen
          </div>
        </div>

        <div className="text-center">
          <div
            className={`text-2xl font-bold ${isState0 || area === 0 ? 'text-gray-300' : 'text-gray-900'}`}
          >
            {areaDisplay}
          </div>
          <div className="text-xs text-gray-500 mt-1">
            Fläche
          </div>
        </div>

        <div className="text-center">
          <div className={`text-2xl font-bold ${isState0 ? 'text-gray-300' : 'text-gray-900'}`}>
            {zonesDisplay}
          </div>
          <div className="text-xs text-gray-500 mt-1">
            Höhenzonen
          </div>
        </div>
      </div>

      {!isState0 && (
        <button
          onClick={() => setActiveView('editor')}
          className="text-[13px] text-emerald-600 hover:text-emerald-700 mt-4 block"
        >
          Grünraum verwalten →
        </button>
      )}
    </section>
  );
};

export default GardenStatsBlock;
